import { render } from "./AgentRenewLicenseReviewDraft.vue?vue&type=template&id=220b7975&scoped=true"
import script from "./AgentRenewLicenseReviewDraft.vue?vue&type=script&lang=js"
export * from "./AgentRenewLicenseReviewDraft.vue?vue&type=script&lang=js"

import "./AgentRenewLicenseReviewDraft.vue?vue&type=style&index=0&id=220b7975&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220b7975"]])

export default __exports__